/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_Footer_NoteInputs */

const en_wallet_card_footer_note = /** @type {(inputs: Wallet_Card_Footer_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note: This card does not guarantee coverage. · Underwriter: ---`)
};

const fr_wallet_card_footer_note = /** @type {(inputs: Wallet_Card_Footer_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remarque : Cette carte ne garantit pas la couverture. · Souscripteur : ---`)
};

/**
* | output |
* | --- |
* | "Note: This card does not guarantee coverage. · Underwriter: ---" |
*
* @param {Wallet_Card_Footer_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_footer_note = /** @type {((inputs?: Wallet_Card_Footer_NoteInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_Footer_NoteInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_footer_note(inputs)
	return fr_wallet_card_footer_note(inputs)
});